module.exports = __webpack_public_path__ + "img/08.76d33acb.jpg";